/**
 * @description 封装axios异步请求
 */

import axios from 'axios'
const enableCache = process.env.VUE_APP_API_CACHE

let cacheRequestInterceptor // 全局缓存请求拦截器
let cacheResponseInterceptor // 全局缓存响应拦截器

// 设置缓存
const setCacheData = (key, value) => {
  try {
    if (!localStorage) {
      console.warn('运行环境不支持localStorage，无法启用数据缓存功能！')
    } else if (key) {
      if (typeof value === 'string') {
        localStorage.setItem(key, value)
      } else {
        localStorage.setItem(key, JSON.stringify(value))
      }
    } else {
      console.warn('缓存键值不存在！')
    }
  } catch (error) {
    console.error('设置缓存失败：', error)
  }
}

// 获取缓存
const getCacheData = key => {
  if (!localStorage) {
    console.warn('运行环境不支持localStorage，无法启用数据缓存功能！')
  } else if (!key) {
    return {
      // data: {}
    }
  } else {
    try {
      const data = JSON.parse(localStorage.getItem(key)) || {
        // data: {}
      }
      return data
    } catch (error) {
      return localStorage.getItem(key) || {
        // data: {}
      }
    }
  }
}

// 清除缓存
const clearCache = key => {
  if (!localStorage) {
    console.warn('运行环境不支持localStorage，无法启用数据缓存功能！')
  } else if (key) {
    localStorage.removeItem(key)
  } else {
    console.warn('缓存键值不存在！')
  }
}

// 开启缓存
if (enableCache === 'true') {
  if (!localStorage) {
    console.warn('运行环境不支持localStorage，无法启用数据缓存功能！')
  } else {
    // 扩展功能
    axios.prototype.clearCache = clearCache
    axios.prototype.setCacheData = setCacheData
    axios.prototype.getCacheData = getCacheData

    // 注册请求拦截器
    cacheRequestInterceptor = axios.interceptors.request.use(function (config) {
      return config
    }, function (error) {
      console.warn('创建请求失败：', error)
      const url = error.config ? error.config.url : ''
      return Promise.resolve(getCacheData(url))
      // return Promise.reject(error)
    })

    // 注册响应拦截器
    cacheResponseInterceptor = axios.interceptors.response.use(function (response) {
      try {
        const url = response.config.url
        // 更新缓存数据
        setCacheData(url, response)
      } catch (error) {
        console.warn('更新缓存失败：', error)
      }
      return response
    }, function (error) {
      const url = error.config ? error.config.url : ''
      return Promise.resolve(getCacheData(url))
    })
  }
} else { // 注销拦截器
  axios.interceptors.request.eject(cacheRequestInterceptor)
  axios.interceptors.response.eject(cacheResponseInterceptor)
}

export default axios
